<template>
  <div>
    <div class="question">
      <el-form class="el-form-m20" :inline="true" size="small" :model="testPaper">
        <el-form-item class="search-bar">
          <el-input :class="{'w-30vw':normal,'w-100per':!normal}" v-model="testPaper.suject"
                    placeholder="请输入试卷考试工种">
            <el-button class="btn-search" @click="search" icon="el-icon-search" slot="append"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item v-if="normal">
          <el-button-group>
            <el-button v-if="perm.indexOf('testpaper:insert') > -1" type="primary" icon="el-icon-plus"
                       @click="dialogFormVisible=true">
              创建新试卷
            </el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="card-container">
      <el-card class="box-card" shadow="never" v-for="(tpItem, i) in groupList" :key="i">
        <div slot="header" class="clearfix">
          <span v-text="tpItem['paperName']+' / '+tpItem['suject']"></span>
          <el-link style="float: right; padding: 3px 0" type="danger" v-if="perm.indexOf('testpaper:delete') > -1"
                   @click="remove(tpItem['groupId'])">删除
          </el-link>
        </div>
        <div v-for="(qtItem,j) in tpItem['groupData']" :key="j" class="text item">
          <span>
            {{ qtMap[qtItem['questionType']] }}
          </span>
          <span>
            <b>{{ qtItem['number'] }}</b> 个
          </span>
          <span>
            每题 <b>{{ qtItem['score'] }}</b> 分
          </span>
        </div>
        <div class="text">
          <!--          <el-button plain>朴素按钮</el-button>-->
          <el-button-group>
            <el-button type="primary" size="small" v-if="perm.indexOf('testpaper:allot') > -1"
                       @click="configExamList(tpItem['groupId'],tpItem['paperName'],tpItem['suject'])">分配考生
            </el-button>
            <el-button type="primary" size="small"
                       v-if="perm.indexOf('testpaper:export') > -1 && tpItem['groupData'][0]['hasScores']"
                       @click="exportExcel(tpItem['groupId'],tpItem['paperName'],tpItem['suject'])">导出成绩
            </el-button>
          </el-button-group>
          <el-popover
              placement="bottom"
              width="260"
              v-model="popsVisible[i]"
              trigger="click">
            <el-row>
              <el-col :span="12">
                <!-- 最少1分钟 -->
                <el-input-number v-model="testTime" :min="1" size="small"></el-input-number>
              </el-col>
              <el-col :span="4">
                <div class="testTimeUnit">分钟</div>
              </el-col>
              <el-col :span="8">
                <el-button type="primary" size="small" @click="startExam(i,tpItem['groupId'],tpItem['groupData'])">
                  确认时长
                </el-button>
              </el-col>
            </el-row>
            <el-button v-if="perm.indexOf('testpaper:startexam') > -1"
                       :disabled="countDownLabel[tpItem['groupId']]!=='开始考试'" plain slot="reference" type="danger"
                       size="small">
              {{ countDownLabel[tpItem['groupId']] }}
            </el-button>
          </el-popover>

          <!--          <el-button type="info" plain>信息按钮</el-button>-->
          <!--          <el-button type="warning" plain size="small">警告按钮</el-button>-->
          <!--          <el-button type="danger" plain>危险按钮</el-button>-->
        </div>
      </el-card>
    </div>
    <div v-if="groupList.length <= 0" class="empty">暂无数据</div>
    <div>
      <el-pagination
          background
          :layout="'prev, pager, next'"
          :page-size="size"
          :total="total"
          :current-page.sync="index"
          @size-change="sizeChange"
          @current-change="currentChange">
      </el-pagination>
    </div>
    <!--     && (perm.indexOf('course:insert') > -1-->
    <el-dialog v-if="normal"
               @close="cancelForm" :title="title +' / '+scoreTotal+' 分'" width="40%"
               :visible.sync="dialogFormVisible"
               :lockScroll="false" @open="getSuject">
      <el-form ref="testPaperForm" :show-message="true" :model="form" label-position="right" label-width="110px">
        <el-form-item prop="paperName" label="试卷备注" :rules="[{required: true, message: '请输入内容'}]">
          <el-input type="text" v-model="form.paperName" placeholder="请输入试卷备注"></el-input>
        </el-form-item>
        <el-form-item prop="suject" label="考试工种" :rules="[{required: true, message: '请输入内容'}]">
          <el-select class="per100" v-model="form.suject" placeholder="请选择考试工种">
            <el-option
                v-for="(item, i) in sujectList"
                :key="i"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单选抽题数量" :required="true">
          <el-col :span="12">
            <el-form-item prop="qt1.number" :rules="rules">
              <el-input v-model.number="form.qt1.number" placeholder="请输入抽题数量" autocomplete="off">
                <template slot="append">个题</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1" class="separator">×</el-col>
          <el-col :span="11">
            <el-form-item prop="qt1.score" :rules="rules">
              <el-input v-model.number="form.qt1.score" placeholder="请输入分值" autocomplete="off">
                <template slot="append">分/题</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="多选抽题数量" :required="true">
          <el-col :span="12">
            <el-form-item prop="qt2.number" :rules="rules">
              <el-input v-model.number="form.qt2.number" placeholder="请输入抽题数量" autocomplete="off">
                <template slot="append">个题</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1" class="separator">×</el-col>
          <el-col :span="11">
            <el-form-item prop="qt2.score" :rules="rules">
              <el-input v-model.number="form.qt2.score" placeholder="请输入分值" autocomplete="off">
                <template slot="append">分/题</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="对错抽题数量" :required="true">
          <el-col :span="12">
            <el-form-item prop="qt3.number" :rules="rules">
              <el-input v-model.number="form.qt3.number" placeholder="请输入抽题数量" autocomplete="off">
                <template slot="append">个题</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1" class="separator">×</el-col>
          <el-col :span="11">
            <el-form-item prop="qt3.score" :rules="rules">
              <el-input v-model.number="form.qt3.score" placeholder="请输入分值" autocomplete="off">
                <template slot="append">分/题</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="confirmForm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog v-if="normal"
               @close="cleanExamStudents" :title="examListTitle" width="60%" :visible.sync="dialogExamListVisible"
               :lockScroll="false" @open="initClassRoom">
      <el-row>
        <el-col :span="10">
          <el-row>
            <el-tag class="el-icon-tickets m-btm-10 configTestList">
              备考人员名单
            </el-tag>
          </el-row>
          <el-tag class="m-rt-2" v-for="stu in examStudents" :key="stu.openId"
                  closable
                  type="info" @close="removeStuFromExamRoom(stu)">
            {{ stu['name'] }}
          </el-tag>
          <div v-if="!examStudents || examStudents.length <= 0">
            没有备考人员，请从右边选择班级，添加名单
          </div>
        </el-col>
        <el-col :span="14">
          <class-room ref="clsRoom" :normal="false" @rowSelected="selectedRow"></class-room>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogExamListVisible=false">取 消</el-button>
        <el-button size="small" icon="el-icon-setting" @click="resetExam">重新分配</el-button>
        <el-button size="small" icon="el-icon-s-fold" @click="addClsIntoExamRoom">添加考试班级</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import helper from "@/common/CZHelper";
import ClassRoom from "@/views/ClassRoom";
import CZHelper from "@/common/CZHelper";

export default {
  name: "TestPaper",
  components: {ClassRoom},
  props: {
    normal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      title: "添加试卷",
      examListTitle: "配置考试名单",
      apiUrl: process.env.VUE_APP_URL,
      dialogFormVisible: false,
      dialogExamListVisible: false,
      currentGroupId: '',
      qtMap: {"radio": "单选", "check": "多选", "rightAndWrong": "对错"},
      groupList: [],
      sujectList: [],
      examStudents: [],
      testTime: 60,
      clsSeletedRows: [],
      list: [],
      total: 0,
      size: this.normal ? 12 : 6,
      index: 1,
      scoreTotal: 100,
      form: {
        suject: null,
        paperName: null,
        qt1: {
          questionType: "radio",
          number: 30,
          score: 2
        },
        qt2: {
          questionType: "check",
          number: 10,
          score: 2
        },
        qt3: {
          questionType: "rightAndWrong",
          number: 10,
          score: 2
        }
      },
      countDown: Array(12).fill(60),
      popsVisible: Array(12).fill(false),
      countDownLabel: {},
      testPaper: {
        "suject": null
      },
      rules: [
        {required: true, message: '请输入内容'},
        {type: 'number', message: '必须为数字值'}
      ],
      perm: localStorage.getItem('perm').split(","),
    }
  },
  beforeRouteEnter(to, from, next) {
    //获取不了this，会携带请求头
    next(self => {
      self.getList();
    });
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        this.scoreTotal = newVal.qt1.score * newVal.qt1.number + newVal.qt2.score * newVal.qt2.number + newVal.qt3.score * newVal.qt3.number
      },
      deep: true
    }
  },
  methods: {
    removeStuFromExamRoom(stu) {
      this.$axios.post(this.apiUrl + 'ma/testpaper/exam/removeStudent', {
        grouping: this.currentGroupId,
        openId: stu.openId
      }).then(({data}) => {
        if (data.code === 200) {
          this.$message.success(stu.name + "成功移除考试名单");
          // 数组splice是深入响应式的，不用回写
          this.examStudents.splice(this.examStudents.indexOf(stu), 1);
        } else {
          this.$message.error(stu.name + "移除考试名单失败");
        }
      });
    },
    resetExam() {
      this.$axios.post(this.apiUrl + 'ma/testpaper/exam/remove', {grouping: this.currentGroupId}).then(({data}) => {
        if (data.code === 200) {
          this.$message.success("重新分配成功");
          this.examStudents = [];
        } else {
          this.$message.error("重新分配失败");
        }
      });
    },
    cleanExamStudents() {
      this.examStudents = [];
    },
    configExamList(groupId, paperName, suject) {
      this.currentGroupId = groupId;
      this.examListTitle = '配置考试名单 # ' + paperName + " / " + suject;
      this.dialogExamListVisible = true;
    },
    exportExcel(groupId, paperName, suject) {
      this.$axios({
        url: this.apiUrl + 'ma/testpaper/exportExcel',
        data: {"grouping": groupId},
        method: 'post',
        responseType: 'arraybuffer'
      }).then((resp) => {
        if (resp.status !== 200) {
          this.$message.error("成绩导出失败");
        } else {
          helper.ajaxDownload(resp, paperName + '-' + suject + '.xlsx');
        }
      });
    },
    selectedRow(val) {
      this.clsSeletedRows = val;
    },
    addClsIntoExamRoom() {
      if (this.clsSeletedRows.length > 0) {
        let clsIdsArray = this.clsSeletedRows.map(item => item.id);
        let clsIdsString = clsIdsArray.join(",");
        let param = {clsIds: clsIdsString, grouping: this.currentGroupId};
        this.$axios.post(this.apiUrl + 'ma/testpaper/addClsIntoExamRoom', param).then(({data}) => {
          if (data.code === 200) {
            this.$message.success("考试班级分配成功");
            this.dialogExamListVisible = false;
          } else {
            this.$message.error("考试班级分配失败，可能没有学生");
          }
        });
      } else {
        this.$message.warning("请选择要添加的班级");
      }
    },
    initClassRoom() {
      this.$nextTick(() => {
        this.$refs['clsRoom'].getList();
        this.$refs['clsRoom'].cleanSeletedRows();
      });
      this.getExamStudents();
    },
    getExamStudents() {
      this.$axios.post(this.apiUrl + 'ma/testpaper/student/list', {grouping: this.currentGroupId}).then(({data}) => {
        if ((data != null && data.length > 0)) {
          this.examStudents = data;
        }
      });
    },
    search() {
      this.getList();
    },
    // 分页大小改变回调
    sizeChange(val) {
      this.size = val;
      this.getList();
    },
    // 页码改变回调
    currentChange(val) {
      this.index = val;
      this.getList();
    },
    getList() {
      let params = {
        index: this.index,
        size: this.size * 3,
        testPaper: JSON.stringify(this.testPaper)
      };
      this.groupList = [];
      helper.getList(this.apiUrl + 'ma/testpaper/list', params, this, this.callback);
    },
    getSuject() {
      this.$axios.get(this.apiUrl + 'ma/topic/suject/list').then(({data}) => {
        this.sujectList = data;
        // 获取考试工种在open事件，所以重置表单
        this.$refs['testPaperForm'].resetFields();
      });
    },
    callback({data}) {
      if (data) {
        // console.log(data);
        // 去重
        let tmp = Array.from(new Set(this.list.map(item => item.tpGrouping + ',' + item.suject + ',' + item.paperName)));
        // 数据重组，一个grouping一组数据
        tmp.forEach((item) => {
          let tmpKeys = item.split(",");
          this.groupList.push({
            "groupId": tmpKeys[0],
            "suject": tmpKeys[1],
            "groupData": this.list.filter(d => d.suject == tmpKeys[1] && d.tpGrouping == tmpKeys[0]),
            "paperName": tmpKeys[2]
          });
          this.countDownLabel[tmpKeys[0]] = '开始考试';
        });
        this.total /= 3;
      }
      // 初始化所有考试信息以后，才获取在线考试的
      this.getExamOnline();
    },
    getExamOnline() {
      this.$axios.get(this.apiUrl + 'testpaper/examttl').then(({data}) => {
        if (data.code === 200) {
          let temp = JSON.parse(data.message);
          for (let k in temp) {
            //服务端59秒以下，是0分钟，+1修正
            this.countDownMethod((temp[k] + 1), k);
          }
        }
      });
    },
    remove(groupId) {
      this.$confirm('此操作会同时删除考生成绩并不能恢复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        this.$axios.post(this.apiUrl + "ma/testpaper/remove", {grouping: groupId}).then(response => {
          if (response.data.code === 200) {
            this.getList();
          }
        });
      }).catch(() => {
        //    点击取消按钮的操作，没有会报错
      });
    },
    cancelForm() {
      this.dialogFormVisible = false;
    },
    startExam(i, groupId, qt) {
      let param = {grouping: groupId, qt: JSON.stringify(qt), testTime: this.testTime};
      this.$axios.post(this.apiUrl + 'ma/testpaper/begin', param).then(({data}) => {
        if (data.code === 200) {
          this.countDownMethod(this.testTime, groupId);
        } else {
          this.$message.error('创建试卷失败');
        }
      });
      // 关闭弹出，深入响应式，因为是数组，引用类型，用复制运算不会更新 view
      this.$set(this.popsVisible, i, false);
    },
    countDownMethod(time, groupId) {
      // 每分钟本地更新一次，不请求服务器，有1-59秒延时
      // 做一次深拷贝，要不感知不了对象的变化
      this.countDownLabel = JSON.parse(JSON.stringify(this.countDownLabel));
      this.$set(this.countDownLabel, groupId, time + "分后停考");
      let downCounter = setInterval(() => {
        if (time <= 1) {
          this.$set(this.countDownLabel, groupId, '开始考试');
          clearInterval(downCounter);
        } else {
          this.$set(this.countDownLabel, groupId, --time + "分后停考");
        }
      }, 60000)
    },
    confirmForm() {
      this.$refs['testPaperForm'].validate((valid) => {
        if (valid) {
          this.$axios.post(this.apiUrl + 'ma/testpaper/add', {
            suject: this.form.suject,
            paperName: this.form.paperName,
            qt1: JSON.stringify(this.form.qt1),
            qt2: JSON.stringify(this.form.qt2),
            qt3: JSON.stringify(this.form.qt3),
          }).then(({data}) => {
            if (data.code === 200) {
              this.getList();
              this.dialogFormVisible = false;
            } else {
              this.$message.error('创建试卷失败');
            }
          });
        }
      });
    }
  }
}
</script>

<style scoped>
@import "../css/common.css";


.empty {
  background: white;
  font-size: 14px;
  color: #909399;
  text-align: center;
  padding: 20px 0
}

.configTestList {
  width: 100%;
  margin-top: 1px;
}

.testTimeUnit {
  text-align: center;
  line-height: 33px;
}

.per100 {
  width: 100%;
}

.separator {
  text-align: center;
}

.question {
  padding: 0 10px;
  display: block;
}

.card-container {
  padding: 0 10px;
  display: flex;
  flex-flow: wrap;
}

.text {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  width: calc(100% / 4 - 2px);
  /*height: 194px;*/
}

</style>